<br>
<ng-container>

  <p class="textSubHeader">
    Mi agenda
  </p>

  <p class="textHeader">
    Atiéndete con nosotros
  </p>
</ng-container>

<app-steps-on-demand [steps]="steps" [tiempoEspera]="tiempoEspera"
  [showSuccessMessage]="showSuccessMessage"></app-steps-on-demand>

<div class="col-12 mt-4 sm-7 text-sm-left container-subtitle-bar">
  <div class="row">
    <div [ngClass]="{ 'col-12': steps.completeForm,'col-8': steps.payment || steps.showSummary }">
      <h3 class="text-select-date m-0">{{ subtitle }}</h3>
    </div>


    <div class="col-4 text-right" style="display: flex;
      align-items: center;
      justify-content: flex-end;">
      <a href="javascript:void(0);" (click)="checkStep()" *ngIf="!steps.completeForm && !showSuccessMessage"
        class="d-flex">
        <i class="material-icons">chevron_left</i>
        <span class="ml-2">Volver</span>
      </a>
    </div>
    <!-- <div class="col col-md-4 txt-right" style="display: flex;
      align-items: center;
      justify-content: flex-end;" *ngIf="data_pending_appo.id_consulta">
        <a href="javascript:void(0);" routerLink="/dashboard" class="d-flex">
          <i class="material-icons">chevron_left</i>
          <span class="ml-2">Salir de la reserva</span>
        </a>
      </div> -->
  </div>

  <div class="row cardInfo" style="display: flex; flex-direction: row;
      padding: 10px;">
    <div class="col-md-1 col-2" style="display: flex; justify-content: center; align-items: center;">
      <mat-icon style="color: #171994; font-size: 30px;">info</mat-icon>
    </div>
    <div class="col-md-11 col-10" style="align-self: center; padding-left: 0;">
      <p class="infoStyleText" style="text-align: justify;"><b>Importante</b>: Este servicio no es una atención de
        urgencia. Si presentas síntomas graves como dificultad respiratoria, pérdida de conciencia o dolor intenso,
        dirígete a un centro médico presencial.</p>
    </div>
  </div>
</div>


<!-- Paso 1 -->
<form [formGroup]="onDemandForm" (ngSubmit)="onSubmit()">
  <div class="col-12 mt-sm-4 text-sm-left ml-sm-3 ml-3 p-0" *ngIf="steps.completeForm">

    <div class="row container-profesional-detail p-3">
      <div class="col-12 col-sm-4 text-center text-sm-left mt-sm-2">
        <div class="row">

          <div class="col-12 info-col">
            <div>
              <span class="remember-text">Área médica <span style="font-size: 20px; font-weight: 600;"></span></span>
            </div>
            <div class="row mb-3 info-select">
              <select class="custom-select select-user mb-sm-2" formControlName="area_medica"
                (change)="changeSpeciality($event)">
                <option value="" selected>Seleccione un área médica</option>
                <ng-container *ngFor="let speciality of especialidades_disponibles">
                  <option [value]="speciality.spe_id">{{speciality.spe_name}}</option>
                </ng-container>
              </select>
            </div>

          </div>

          <p *ngIf="compatibleSpecialities.length <= 0" class="description remember-text">No posees planes o
            convenios
            disponibles para atenderte con este profesional</p>

          <ng-container style="display: none !important;">
            <div class="col-12 info-col" style="display: none !important;">
              <span class="remember-text">Paciente <span style="font-size: 20px; font-weight: 600;"></span></span>
              <div class="row mb-3 info-select">
                <input class="form-control select-user mb-sm-2" type="text" formControlName="paciente"
                  [value]="beneficiarySelected.use_id" readonly />
              </div>
            </div>
          </ng-container>
          <ng-container>
            <div class="col-12 info-col">
              <span class="remember-text">Paciente <span style="font-size: 20px; font-weight: 600;"></span></span>
              <div class="row mb-3 info-select">
                <input class="form-control select-user mb-sm-2" type="text"
                  [value]="beneficiarySelected.use_name + ' ' + beneficiarySelected.use_paternal_surname" readonly />
              </div>
            </div>
          </ng-container>




        </div>
      </div>
      <div class="col-12 col-sm pl-0 pl-sm-3 mt-sm-2">
        <span class="remember-text">Motivo de consulta / síntomas <span style="font-size: 20px; font-weight: 600; ">
          </span></span>
        <textarea class="reason p-3 p-sm-3 info-select" placeholder="Motivo de consulta / síntomas"
          name="appointment_reason" id="appointment_reason" formControlName="reason"></textarea>

        <br>
        <br>

      </div>

      <div class="form-check planes col-12 p-0">

        <div>
          <span class="remember-text ml-0">Consentimiento informado <span
              style="font-size: 20px; font-weight: 600;"></span></span>
        </div>
        <input mdbCheckbox class="form-check-input" type="checkbox" id="flexCheckTerms" formControlName="terminos" />
        <label class="form-check-label" for="flexCheckTerms">
          Acepto consentimiento informado para consulta de telemedicina.
          <b class="terminos-condiciones" data-toggle="modal" data-target="#modalTerms">
            <span class="verMas">(Ver detalle)</span>
          </b>
        </label>
      </div>

      <div class="col-12 footerReserva">
        <!-- <div class="col-6 col-sm-6 col-md-6 text-sm-left pl-0" style="max-width: 100%; display: flex;">
                    <span class="text-danger" style="font-size: 16px; font-weight: 600;">(*) Campos obligatorios</span>
                </div> -->
        <div class="col-12 text-center pr-sm-0  text-sm-right boton-col" style="max-width: 100%;">
          <button *ngIf="(_usuario.typ_id == 2)" type="button" class="btn btn-primary btn-available"
            style="background: #316AD8; border-radius: 30px; font-family: 'Mulish'; border: #316AD8; box-sizing: border-box; color: white;"
            (click)="redirectToStep2()">
            Continuar
          </button>


        </div>



      </div>
    </div>

  </div>
  <!-- FIN Paso 1 -->

  <!-- Paso 2 -->

  <div class="col-12 mt-sm-4 text-sm-left ml-sm-3 ml-3 p-0" *ngIf="steps.payment">

    <div class="row container-profesional-detail p-3">

      <div class="col-12 medio-pago">
        <span class="remember-text mb-1">Prestación</span>
        <div>
          <ng-container>
            <div class="row">
              <div class="col-md-12">
                <span class="detalle">{{specialitySelected.spe_name }}</span>
              </div>
            </div>
          </ng-container>
        </div>
        <hr>
      </div>
      <!-- MEDIO DE PAGO (WEBPAY / SNABB) -->
      <ng-container *ngIf="pageInfo.cus_can_pay || pageInfo.cus_can_snabb">
        <div class="col-12 container-convenios">
          <span class="remember-text">Medio de pago</span>

          <div style="margin: 10px 10px 10px 10px;">
            <br />

            <div class="row">

              <!-- SNABB -->
              <div class="col-12 col-lg-6 planes" style="margin-right: -10px !important" *ngIf="pageInfo.cus_can_snabb">
                <div class="planes-items2" (click)="togglePaymentProvider('SNABB', $event)">
                  <div class="col-md-1">
                    <mat-checkbox class="m-0 primary" [checked]="selectedPaymentProvider === 'SNABB'"
                      (click)="$event.stopPropagation()" (change)="togglePaymentProvider('SNABB', $event)">
                    </mat-checkbox>
                  </div>

                  <div>
                    <img class="image-medio" src="./assets/images/gallery/logo-fonasa.png"
                      style="width: 160px; max-width: 100%; height: auto;" alt="Snabb">
                  </div>
                </div>
              </div>

              <!-- WEBPAY -->
              <div class="col-12 col-lg-6 planes" style="margin-right: -10px !important" *ngIf="pageInfo.cus_can_pay">
                <div class="planes-items2" (click)="togglePaymentProvider('WEBPAY', $event)">
                  <div class="col-md-1">
                    <mat-checkbox class="m-0 primary" [checked]="selectedPaymentProvider === 'WEBPAY'"
                      (click)="$event.stopPropagation()" (change)="togglePaymentProvider('WEBPAY', $event)">
                    </mat-checkbox>
                  </div>

                  <div>
                    <img class="image-medio" src="./assets/images/gallery/webpay-logo.png"
                      style="width: 160px; max-width: 100%; height: auto;" alt="Webpay">
                  </div>
                </div>
              </div>

            </div>
            <div class="not-plans mt-4" *ngIf="selectedPaymentProvider == 'SNABB'">
              <div style="display: flex; flex-direction: row; ">
                <i class="material-icons">info</i>
                <span>Esta atención está sujeta a copago según las condiciones de FONASA.</span>
              </div>
            </div>

            <div *ngIf="isWaitingVoucher" class="mt-3">
              <small>Generando voucher FONASA… por favor espera.</small>
            </div>

          </div>

          <hr>
        </div>
      </ng-container>





      <div class="col-12 container-convenios">
        <span class="remember-text convenios ">Convenio</span>

        <div class="not-plans" *ngIf="planesDisponibles == 0">
          <div style="display: flex; flex-direction: row; ">
            <i class="material-icons">info</i>
            <span>No tienes planes o convenios activos que incluyan esta prestación. Para contratar un plan
              o convenio
              dirigete a https://almamedis.cl o comunícate con tu proveedor o sponsor.</span>
          </div>
        </div>


        <div style="margin: 40px 0px 10px 10px;" *ngFor="let plan of planesDisponibles" class="planes">
          <ng-container>

            <div class="row planes-items" (click)="planRowSelected(plan)">
              <div class="col-md-1">
                <mat-checkbox class="example-margin primary" [checked]="plan.ben_id === planSelected?.ben_id"
                  [disabled]="true">
                </mat-checkbox>
              </div>
              <div class="col-md-4">
                <img [src]="plan.image_plan" alt="auto" width="50%" class="image-medio">
              </div>
              <div class="col-md-4">
                {{ plan.cus_ben_name }}
              </div>
              <div class="col-md-3" style="text-align: left;">
                <ng-container *ngFor="let especialidad of plan.especialidades">
                  <ng-container *ngIf="specialitySelected.spe_id === especialidad.spe_id">
                    <a>Subvención: {{especialidad.porcentaje_descuento}}%</a>
                    <br>
                    <a *ngIf="especialidad.cantidad_consultas">
                      Consultas disponibles: {{especialidad.cantidad_consultas - especialidad.consultas_usadas}}
                    </a>
                    <a *ngIf="!especialidad.cantidad_consultas">
                      Consultas disponibles: Ilimitadas
                    </a>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <br>
          </ng-container>
        </div>
        <br>
        <hr>
      </div>

      <div class="col-12 planes">
        <span class="remember-text terminos-condiciones">Código de descuento </span>

        <div>
          <ng-container>
            <div class=row>
              <div class="col-md-6 col-sm-12 d-flex">
                <br>
                <input type="text" class="form-control" formControlName="discountCode"
                  placeholder="Ingrese un codigo de descuento">

                <p class="form-text text-success"
                  *ngIf="discountCodeObject.dis_id && discountCodeObject.status; else codigoValido">
                  *Código de descuento ingresado exitosamente
                </p>
                <ng-template #codigoValido>
                </ng-template>

                <p class="form-text text-danger"
                  *ngIf="discountCode && !discountCodeObject.status; else codigoInvalido">
                  *Código de descuento no valido
                </p>
                <ng-template #codigoInvalido>
                </ng-template>

                <!-- <p *ngIf="discountCodeObject.dis_id && discountCodeObject.status" class="form-text text-success">****Código de descuento ingresado exitosamente</p>
                  <p *ngIf="discountCode && !discountCodeObject.status" class="form-text text-danger">*Código de descuento expirado</p> -->
              </div>

              <div class="col-md-6 col-sm-12 boton-dcto">

                <button type="button" class="btn btn-aplicar" (click)="validarDcto()">Aplicar</button>
              </div>
            </div>

          </ng-container>

          <br>
          <hr>
        </div>
        <div class="col-md-4 col-sm-12 medio-pago p-0" *ngIf="pageInfo.cus_can_pay">
          <span class="remember-text m-0">Resumen del pago</span>
          <br>
          <div class="medio-pago m-0">
            <ng-container>
              <div class=" row texto-pago">

                <div class="col-6">
                  <p>Subtotal: </p>
                </div>
                <div class="col-6 monto">
                  <p style="text-align: end;">${{paymentInfo.originalValue | puntoMiles}}</p>
                </div>
              </div>
            </ng-container>
            <!-- Descuento convenio -->
            <!-- <ng-container *ngIf="!data_pending_appo.id_consulta"> -->
            <div class=" row texto-pago">
              <div class="col-6">
                <p>Descuento convenio: </p>
              </div>
              <div class="col-6 monto " *ngIf="planSelected.ben_id">
                <p style="text-align: end;">-${{paymentInfo.inssuranceDiscountValue | puntoMiles }}</p>
              </div>
              <div class="col-6 monto" *ngIf="!planSelected.ben_id">
                <p style="text-align: end;">-$0</p>
              </div>
            </div>
            <!-- </ng-container> -->
            <!-- Descuento codigo -->
            <ng-container>
              <div class=" row texto-pago">
                <div class="col-6">
                  <p>Descuento código: </p>
                </div>
                <div class="col-6 monto">
                  <p style="text-align: end;">-${{paymentInfo.discountValue | puntoMiles }}</p>
                </div>
              </div>
            </ng-container>
            <hr>
            <!-- Valor total -->
            <ng-container>
              <div class=" row texto-pago-total">
                <div class="col-6">
                  <p>Valor total: </p>
                </div>
                <div class="col-6 monto">
                  <p style="text-align: end;">${{paymentInfo.finalValue | puntoMiles }}</p>
                </div>
                <!-- <div class="col-md-6 monto" *ngIf="planSelected.ben_id">
                            <p>${{paymentInfo.finalValue | puntoMiles }}</p>
                          </div>
                          <div class="col-md-6 monto" *ngIf="!planSelected.ben_id && !paymentInfo.discountValue">
                            <p>${{paymentInfo.originalValue | puntoMiles }}</p>
                          </div> -->
              </div>
            </ng-container>
          </div>
        </div>
      </div>


      <div class="col-md-6 col-sm-12">
        <div class>
          <span class="remember-text planes ">Términos y condiciones </span>
        </div>


        <div class="form-check planes">
          <input mdbCheckbox class="form-check-input" type="checkbox" formControlName="acceptTerms"
            id="flexCheckTerms" />
          <label class="form-check-label" for="flexCheckTerms">
            Acepto términos y condiciones.
          </label>

          <b class="terminos-condiciones" data-toggle="modal" data-target="#modalTerms2"><span class="verMas"> (Ver
              más).</span></b>

          <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong">
                  Terminos y condiciones
                </button> -->
        </div>
      </div>

      <div class="col-md-6 col-sm-12 boton-col">
        <button *ngIf="(_usuario.typ_id == 2 && paymentInfo.finalValue > 0)" type="button"
          class="btn btn-primary btn-available"
          style="background: #316AD8; border-radius: 30px; font-family: 'Mulish'; border: #316AD8; box-sizing: border-box; color: white;"
          (click)="redirectToStep3()">
          Pagar
        </button>

        <button *ngIf="(_usuario.typ_id == 2 && paymentInfo.finalValue == 0)" type="button"
          class="btn btn-primary btn-available"
          style="background: #316AD8; border-radius: 30px; font-family: 'Mulish'; border: #316AD8; box-sizing: border-box; color: white;"
          (click)="redirectToStep3()">
          Continuar
        </button>

      </div>



    </div>
  </div>
  <!-- FIN Paso 2 -->

  <!-- paso 3 -->

 <!-- =====================================================
     PASO 3 - FILA VIRTUAL
====================================================== -->

<div
  class="col-12 mt-sm-4 text-sm-left p-0"
  *ngIf="steps.showSummary">

  <!--
    Este contenedor SOLO organiza las 2 cards.
    No tiene fondo, borde ni border-radius.
  -->
  <div class="virtual-queue-layout">


    <!-- =================================================
         CARD 1 - 60%
         CONFIRMACIÓN FILA VIRTUAL
    ================================================== -->

    <div class="container-summary virtual-queue-main-card">

      <div class="virtual-queue-main">


        <!-- IMAGEN -->

        <div class="virtual-queue-image">

          <img
            class="image-doctor-od"
            src="./assets/images/reserva.png"
            alt="Ingreso a fila virtual">

        </div>


        <!-- MENSAJE PRINCIPAL -->

        <div class="confirm-od virtual-queue-title">

          <span>
            ¡Haz ingresado con éxito a nuestra fila virtual!
          </span>

        </div>


        <!-- SUBTÍTULO -->

        <div class="confirm-od virtual-queue-subtitle">

          <span class="subtitle">
            Uno de nuestros profesionales te atenderá lo antes posible.
          </span>

        </div>


        <!-- BOTÓN -->

        <div class="virtual-queue-action">

          <button
            *ngIf="_usuario.typ_id == 2"
            type="button"
            class="btn btn-primary btn-available virtual-queue-button"
            (click)="redirectToWaitingRoom()">

            Ingresar a la fila virtual

          </button>

        </div>

      </div>

    </div>


    <!-- =================================================
         CARD 2 - 40%
         RECOMENDACIONES
    ================================================== -->

    <aside class="virtual-queue-tips-card">


      <!-- TÍTULO -->

      <h3 class="virtual-queue-tips-title">

        Mientras esperas, prepara tu conexión

      </h3>


      <!-- =================================================
           RECOMENDACIONES
      ================================================== -->

      <div class="virtual-queue-tips-list">


        <div class="virtual-queue-tip-item">

          <mat-icon class="virtual-queue-check">
            check
          </mat-icon>

          <span>
            Usa una conexión a internet estable y rápida.
          </span>

        </div>


        <div class="virtual-queue-tip-item">

          <mat-icon class="virtual-queue-check">
            check
          </mat-icon>

          <span>
            Permite el acceso a tu cámara y micrófono cuando
            el navegador lo solicite.
          </span>

        </div>


        <div class="virtual-queue-tip-item">

          <mat-icon class="virtual-queue-check">
            check
          </mat-icon>

          <span>
            Ingresa desde Google Chrome para la mejor experiencia.
          </span>

        </div>


        <div class="virtual-queue-tip-item">

          <mat-icon class="virtual-queue-check">
            check
          </mat-icon>

          <span>
            Evita usar equipos corporativos con VPN o bloqueos
            de seguridad de video y audio.
          </span>

        </div>


        <div class="virtual-queue-tip-item">

          <mat-icon class="virtual-queue-check">
            check
          </mat-icon>

          <span>
            Cierra otras aplicaciones que puedan estar usando
            tu cámara o micrófono (Zoom, Teams, Meet, etc.).
          </span>

        </div>

      </div>


      <!-- =================================================
           SEPARADOR
      ================================================== -->

      <div class="virtual-queue-help-divider">
      </div>


      <!-- =================================================
           MESA DE AYUDA
      ================================================== -->

      <div class="virtual-queue-help">

        <span>

          ¿Tuviste un problema técnico o el profesional no se presentó?
          Llama a Mesa de ayuda:

        </span>

        <strong>
          800 248 030
        </strong>

      </div>

    </aside>

  </div>

</div>




</form>
<div class="modal fade" id="modalTerms" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-body modal-scrollable">
        <!-- Agrega la clase "modal-scrollable" al elemento "modal-body" -->
        <div class="modal-content-scroll">

          <h5 id="exampleModalLongTitle">Consentimiento Informado:</h5>
          <br>
          <div class="terminos-condiciones">

            <h4>Teleconsulta y Atención Inmediata</h4>
            <br>
            <h4>Teleconsulta:</h4>
            Una teleconsulta en AlmaMedis consiste en una atención realizada por un profesional de la salud
            a través de una videollamada, en la cual participan el profesional, el paciente y un acompañante
            si es necesario. Esta atención se realiza utilizando nuestra plataforma digital de telemedicina,
            permitiendo a los participantes interactuar sin necesidad de estar en el mismo lugar geográfico.
            Esto brinda acceso a una atención de salud desde el hogar, trabajo o cualquier otro lugar.
            <br>
            <br>
            <h4>Atención Inmediata: </h4>
            <br>
            La modalidad de atención inmediata le permitirá recibir una consulta médica en el menor tiempo
            posible. Un médico de nuestra red revisará sus antecedentes y síntomas para brindarle la mejor
            atención posible a través de una videollamada.
            <br>
            <br>
            <h4>¿En qué casos debes preferir una atención por telemedicina?</h4>
            <br>
            Nuestro servicio de telemedicina permite a los pacientes recibir atención a distancia de manera
            segura. Sin embargo, la telemedicina presenta limitaciones para resolver ciertas urgencias
            médicas, como problemas agudos para respirar, fracturas, heridas, quemaduras, dolores intensos
            en el tórax o abdomen, desmayos, entre otros. Asimismo, se debe preferir la atención presencial
            cuando sea necesario realizar un examen físico o una evaluación diagnóstica como ecografías o
            tomografías computarizadas. En caso de emergencia médica, debe asistir presencialmente a un
            centro de salud.
            <br>
            <br>
            <h4>Privacidad y Protección de Datos:</h4>
            <br>
            Su privacidad es nuestra prioridad. Toda la información proporcionada será tratada con la máxima
            confidencialidad y solo será visible para usted y su médico tratante. La información se
            encuentra resguardada con altos estándares de seguridad, utilizando herramientas avanzadas para
            asegurar la confidencialidad, conforme a las normativas vigentes sobre protección de datos
            personales.
            <br>
            <br>
            <h4>Política de Reversas y Devoluciones:</h4>
            <br>
            En caso de que la atención no se complete de manera exitosa, ya sea por salida voluntaria de la fila de
            espera, cancelación antes de ser atendido o problemas de conexión durante la atención, el cobro será
            revertido en su totalidad.
            <br>
            Asimismo, si el paciente ha utilizado un convenio, la consulta no será descontada mientras no se haya
            completado la atención médica.
            <br>

            <br>
            <h4>Consentimiento:</h4>
            <br>
            Al aceptar este consentimiento informado, usted reconoce y acepta que:
            <br>
            <br>
            <ul>
              <li>Ha comprendido la naturaleza de la teleconsulta y la atención inmediata, así como los
                procesos descritos.</li>
              <li>Entiende que la consulta de telemedicina no reemplaza una consulta presencial, debido a
                ciertas limitaciones para realizar diagnósticos certeros, como la imposibilidad de
                realizar un examen físico completo.</li>
              <li>Acepta que una vez realizado el pago, no podrá solicitar la devolución del dinero.</li>
              <li>Acepta que AlmaMedis utilice su dirección e información de consulta para poder entregarle
                recomendaciones de servicios personalizados en su comuna. Compartir esta información no entrega sus
                datos personales a ningún servicio ni proveedor, solo permite generarle ofertas personalizadas.</li>
              <li>Es consciente de que su consulta será atendida por el primer médico disponible en la
                modalidad de atención inmediata.</li>
              <li>Confía en que su información personal será manejada de manera privada y solo será
                accesible por el médico tratante y usted mismo.</li>
              <li>Reconoce que, para la correcta realización de la teleconsulta, debe estar en un lugar
                seguro, privado y con condiciones tecnológicas adecuadas (dispositivo y conexión a
                internet estable). Cualquier falla de conexión no atribuible a AlmaMedis o al
                profesional será responsabilidad del paciente.</li>
              <li>Acepta que los diagnósticos, órdenes, certificados y recetas se generan a partir de la
                información proporcionada, y cualquier inexactitud en la información podría llevar a
                errores en los documentos e indicaciones generadas.</li>
              <li>En caso de ser necesario, según las indicaciones del médico, deberá consultar con otro
                especialista para obtener un diagnóstico más preciso o continuar con un tratamiento de
                manera presencial.</li>
            </ul>
            <h4>Mesa de Ayuda:</h4>
            <br>
            AlmaMedis ofrece una mesa de ayuda telefónica o contact center para soporte y apoyo a los
            participantes y usuarios de la plataforma digital. Para una comunicación adecuada con su médico,
            debe conectarse a su videoconsulta en un lugar tranquilo y sin ruidos externos. De no contar con
            estas condiciones, la consulta podría ser cancelada y requerir un reagendamiento a costo del
            paciente.
            <br>
            <br>
            <h4>Revocación del Consentimiento:</h4>
            <br>
            Usted puede, en cualquier momento, revocar su consentimiento y optar por una atención
            presencial, informando de esto al profesional que lo está atendiendo, quien dará por finalizada
            la consulta.
            Al iniciar la videollamada, el médico le consultará si está de acuerdo con los términos y
            condiciones mencionados en este documento. Si usted está de acuerdo con estos términos, proceda
            a firmar y entregar este consentimiento vía digital al profesional. Al marcar "Aceptar" y
            proceder con el pago, usted confirma que ha leído y comprendido los términos del consentimiento
            informado, acepta las condiciones aquí establecidas y confía en la privacidad y protección de
            sus datos personales.”
            <br>
            <br>

            <br>
            <br>
            <div class="row credenciales" style="justify-content: space-around;">
              <div class="col-md-6 col-sm-12 firmas">
                <div class="nombre-paciente">
                  <div class="contenedor-nombre" style="margin-bottom: 30%; font-size: 15px;">
                    <span>{{beneficiarySelected.use_name}} </span>
                    <span>{{beneficiarySelected.use_paternal_surname}}
                      {{beneficiarySelected.use_maternal_surname}}</span>
                  </div>
                </div>
                <div>
                  <span class="footer-firma">Nombre paciente</span>
                  <hr style="margin-top: 20px; margin-bottom: 4px; border: none;">
                </div>
              </div>
              <div class="col-md-6 col-sm-12 firmas">
                <div style="    display: flex;
                                flex-direction: column;
                                align-items: center;">
                  <img src="assets/images/Firma TG Negra.png" style="width: 60%;">
                  <span class="footer-firma">Tomás Godoy Segovia</span>
                  <span class="footer-firma2">Gerente General AlmaMedis</span>
                </div>
              </div>
            </div>
            <br>
            <br>
            <br>
            <br>
          </div>

        </div>
      </div>
    </div>
    <div class="footer">
      <button type="button" class="btn btn-aplicar" data-dismiss="modal" style="padding: 0 !important">Cerrar</button>
    </div>
  </div>
</div>


<div class="modal fade" id="modalTerms2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-body modal-scrollable">
        <!-- Agrega la clase "modal-scrollable" al elemento "modal-body" -->
        <div class="modal-content-scroll">

          <h5 id="exampleModalLongTitle">TÉRMINOS Y CONDICIONES DE USO DE PLATAFORMA DE TELEMEDICINA ALMAMEDIS.<br>
            NO UTILICE ESTE SITIO WEB EN CASO DE UNA EMERGENCIA O URGENCIA MEDICAS<br>
            SI TIENE UNA EMERGENCIA O URGENCIA DE SALUD DIRIJASE DE INMEDIATO A UN CENTRO DE ATENCIÓN HOSPITALARIA O
            CLINICA.</h5>
          <br>
          <div class="terminos-condiciones">
            <h4>BIENVENIDO</h4>
            <br>
            Usted está accediendo a esta plataforma para poder hacer uso del servicio de asistencia de telemedicina.
            Para estos efectos usted ha contratado los servicios de la asistencia de telemedicina con Almamedis, quien
            ha dispuesto los Términos y Condiciones para el uso de este sitio web, así como de los servicios y las
            herramientas provistas a través de éste, lo que está condicionado a la aceptación por parte de usted de los
            términos de uso descritos a continuación.
            El acceso y uso de este sitio web se rige por los Términos y Condiciones descritos a continuación, así como
            por la legislación que se aplique en la República de Chile a los mismos. En consecuencia, todas las visitas
            y todos los servicios que se realicen en este sitio, como asimismo sus efectos jurídicos, quedarán regidos
            por estas condiciones o reglamento y sometidas a esa legislación.
            Este documento describe los términos, condiciones generales y las condiciones particulares, en adelante
            ("Términos y Condiciones” aplicables al uso de los servicios ofrecidos y/o provistos por Almamedis), dentro
            del sitio web https://telemedicina.almamedis.cl, incluidas las herramientas provistas a través del mismo
            para la realización de video-consultas a distancia e intercambio de información y/o datos personales, en
            adelante también referidos como “Servicios”.
            Cualquier persona que desee usar el Sitio o los Servicios podrá hacerlo previa aceptación de los Términos y
            Condiciones acá descritos.
            <br>
            <br>
            <h4>CUALQUIER PERSONA QUE NO ACEPTE ESTOS TÉRMINOS Y CONDICIONES, LOS CUALES TIENEN UN CARÁCTER OBLIGATORIO
              Y
              VINCULANTE, DEBERÁ ABSTENERSE DE UTILIZAR EL SITIO Y/O LOS SERVICIOS ASOCIADOS AL MISMO.</h4>
            <br>
            Usted debe leer, entender y aceptar todas las condiciones establecidas en los Términos y Condiciones, previo
            a su inscripción como Usuario de Almamedis.
            Debe entender que las interacciones con los proveedores de servicios de consulta médica a través de
            Almamedis son un complemento de la relación personal que pueda tener con un profesional de la salud. Por
            consiguiente, los servicios ofrecidos por Almamedis no están necesariamente destinados a sustituir los
            exámenes físicos o controles regulares de salud que puede realizar o le aconseje un profesional de salud.
            <br>
            <br>
            <h4>INDEPENDENCIA DE CRITERIO PROFESIONAL</h4>
            <br>
            Usted entiende y acepta que Almamedis presta sus servicios vía plataforma web, para atenciones de salud, las
            que son efectuadas bajo el conocimiento y criterio del profesional respectivo.
            Todos los profesionales de la salud que se encuentran disponibles para consultas “on-line”, ofrecen sus
            servicios en el libre ejercicio de su profesión y utilizan Almamedis como un medio para comunicarse con
            Usted o su beneficiario.
            Cualquier información, recomendación, indicación o diagnóstico recibido de un “Profesional de la salud” a
            través de Almamedis, proviene exclusivamente de aquel, no pudiendo Almamedis intervenir en el acto
            profesional mismo, ya sea que se trate de diagnóstico, medicación, tratamiento u otros. Sin perjuicio de
            ello, Almamedis, es responsable de la elección de los profesionales que acceden a la plataforma y de
            chequear sus títulos o habilitaciones profesionales, de manera que quienes prestan su servicio mediante la
            plataforma Almamedis sean profesionales habilitados en Chile para el ejercicio de la profesión médica.
            <br>
            <br>
            <h4>SEGURIDAD Y FUNCIONAMIENTO DE LA PLATAFORMA Y EL SERVICIO</h4>
            <br>
            Queda establecido que Almamedis implementará y ejecutará todos los procedimientos y estándares de seguridad
            de la información que adhieren a la norma ISO27001, de modo de proteger su privacidad y limitar el riesgo de
            pérdida de información.
            Usted conoce y acepta que para el adecuado funcionamiento de la plataforma Almamedis debe contar con una
            conexión a internet de banda ancha estable y un dispositivo electrónico con las características técnicas
            suficientes para reproducir una videoconferencia. Almamedis no se responsabiliza de una interrupción en el
            servicio a causa de fallas en la conexión que provengan de la calidad de la banda ancha y/o de los equipos
            electrónicos de su propiedad.
            <br>
            <br>
            <h4>SELECCIÓN DE PROFESIONALES MÉDICOS DISPONIBLES</h4>
            <br>
            Cuando el Paciente o “Usuario” solicita una consulta para obtener la atención de un “Profesional de la
            salud”, Almamedis le ofrecerá la opción de consultar con cualquier profesional independiente afiliado a
            nuestra red, que se encuentre disponible para atenderlo. Para su tranquilidad, Almamedis selecciona a
            profesionales de la salud que cumplen con los requisitos que la legislación vigente en nuestro país para
            proveer los servicios que ofrecen.
            Cuando Usted solicita una consulta, está aceptando específicamente que el “Profesional de la salud” que
            Usted ha seleccionado podrá, desde ese momento, acceder a su historial clínico que se encuentre disponible
            en la plataforma. Igualmente, al solicitar una consulta, usted está dando inicio a una relación directa
            “Profesional de la salud” – “Usuario”, a través de la plataforma de telemedicina de Almamedis.
            <br>
            <br>
            <h4>RESPONSABILIDAD</h4>
            <br>
            Almamedis es responsable de contar con una red de profesionales de salud idóneos que cumplan con la
            normativa vigente para ejercer su profesión en Chile.
            <br>
            <br>
            <h4>REGISTRO COMO USUARIO</h4>
            <br>
            Para tener acceso a los servicios en línea, deberá registrarse como “Usuario” y deberá crear una cuenta
            personal, suministrando la información que se solicita. Con la excepción de las cuentas de sus asegurados
            adicionales cuando corresponda, Usted acuerda no crear más de una cuenta de usuario, ni crear una cuenta
            para otra persona, si no ha sido autorizado de manera expresa y escrita. Asimismo, Usted se compromete a
            proveer información correcta, verdadera y actualizada al momento de registrarse o cuando realice la
            actualización de su ficha de información personal para así permitir una buena gestión en trámites como
            cambios de contraseña, recepción de comprobantes de venta y confirmación de horas médicas.
            <br>
            <br>
            <h4>SEGURIDAD</h4>
            <br>
            Al registrarse, deberá ingresar sus datos y una clave de acceso (la cual podrá modificar regularmente).
            Estos datos son personales e intransferibles y usted es responsable de mantener la seguridad de su cuenta,
            cuidando en todo momento la seguridad y confidencialidad de sus claves de acceso. Usted entiende y acepta
            que en ningún caso podrá facilitar el acceso de terceros a Almamedis mediante el uso de su nombre de usuario
            y contraseña.
            <br>
            <br>
            <h4>POLÍTICA DE PRIVACIDAD</h4>
            <br>
            Almamedis garantiza la confidencialidad “Profesional de la Salud” – “Usuario”. Toda información que
            relacione su identidad con las condiciones físicas y mentales presentes, pasadas o futuras y su historia de
            salud, es considerada información de carácter privado y será tratada como tal.
            Como parte de su proceso operativo, Almamedis registra su información personal y se obliga a no cederla,
            licenciarla o compartirla fuera de Almamedis ni a sus entidades asociadas. Con la aceptación de estos
            Términos y Condiciones, usted nos autoriza desde ya en forma expresa a almacenar y emplear dicha información
            para permitir que Almamedis provea los servicios de telemedicina.
            El usuario gozará de todos los derechos que le reconoce la Ley Nº19.628 sobre protección de datos y la ley
            del consumidor en Chile.
            <br>
            <br>
            <h4>COOKIES</h4>
            <br>
            Como la mayoría de los sitios web, utilizamos "cookies" y archivos de registro web para analizar el uso del
            sitio, para mejorar la calidad de nuestro servicio y con la finalidad de personalizar en la medida de lo
            posible su experiencia en nuestro sitio web. Una cookie es un archivo de datos que reside en su computadora,
            teléfono inteligente, tableta o cualquier otro dispositivo desde el que ingrese y permite su reconocimiento
            como usuario cuando regrese a nuestro sitio web desde el mismo equipo, siempre que utilice el mismo
            navegador.
            Usted tiene el derecho de eliminar o bloquear las cookies de nuestro sitio web utilizando la configuración
            de su navegador, pero esto podría afectar su capacidad para ingresar o utilizar nuestros servicios.
            <br>
            <br>
            <h4>POLÍTICAS Y CONDICIONES DE PAGO</h4>
            <br>
            Al realizar el pago a través del sistema web de Transbank o cualquier otro método que Almamedis estime
            conveniente, usted acepta las condiciones que se establecen a continuación, manifestando su total
            conformidad. Por lo que solicitamos leer con detención los términos y condiciones que rigen el uso de
            nuestra página web, junto con el alcance de la contratación electrónica del servicio de telemedicina.

            El valor del servicio de atención de telemedicina deberá ser pagado antes de recibir la atención, pudiendo
            utilizar las opciones de pago que estarán disponibles en el proceso de agendamiento de la consulta. Las
            formas de pago podrán ser, pero no se limitarán: Transbank y otras tecnologías de pago virtual.

            El servicio de telemedicina deberá ser pagado de forma particular en su totalidad o en parte, dependiendo de
            si se selecciona un plan o convenio. Se podrá gestionar posteriormente el reembolso con la institución de
            salud previsional que tenga el paciente atendido, sin embargo, Almamedis no se responsabiliza en caso de que
            el paciente no tenga la cobertura o la institución de salud previsional se niegue a efectuar el reembolso.
            Si existiera un cobro por uso de un servicio adicional específico, no cubierto en el precio final de la
            atención, usted será informado, de forma previa y a través del sistema, del cargo correspondiente a aplicar
            en el momento de acceder al servicio en cuestión.
            Los servicios ofrecidos en esta plataforma, salvo que se señale un método diferente para casos particulares
            u ofertas de determinados servicios, sólo podrán ser pagados con los medios disponibles y que se indican en
            el sistema. Las tarjetas emitidas en el extranjero no admiten la modalidad de pago en cuotas.
            El uso de las tarjetas se sujetará a lo establecido en estos términos y condiciones y en relación con su
            emisor a lo pactado en los respectivos contratos de apertura y reglamento de uso. En caso de contradicción,
            predominará lo expresado en ese último instrumento. A mayor abundamiento, tratándose de tarjetas bancarias o
            de tarjetas no bancarias aceptadas en este sitio, los aspectos relativos a ésta, tales como la fecha de
            emisión, caducidad, cupo, bloqueos, etc., se regirán por el respectivo contrato de apertura y reglamento de
            uso, de tal forma que Almamedis no tendrá responsabilidad en cualquiera de los aspectos señalados. El sitio
            podrá indicar determinadas condiciones de compra según el medio de pago que se utilice por el usuario.
            <br>
            <br>
            <h4>POLÍTICAS DE CANCELACIÓN, REEMBOLSOS Y NO PRESENTACIÓN</h4>
            <br>
            La cancelación o modificación del servicio debe realizarse antes de las 20:00 horas del día anterior a la
            consulta para que se procese la devolución del cargo de la reserva. Si se realiza con menos tiempo del
            descrito, Almamedis no podrá realizar modificaciones al servicio ni realizar ningún tipo de devolución por
            los servicios contratados.
            En el caso de la cancelación, los servicios que hayan sido reservados utilizando algún plan o convenio en la
            plataforma, no se descontarán de la cantidad total establecida, solo en los casos que dichas cancelaciones
            se hayan realizado con al menos 1 hora de anticipación a la hora de la consulta.

            El profesional de la salud, por protocolo, esperará al paciente hasta 15 minutos posterior a iniciada la
            hora de la consulta. Si en ese periodo de tiempo el paciente no se conecta, es posible que la atención no se
            concrete, a menos que exista una coordinación externa entre paciente y profesional de la salud apoyada por
            la mesa de ayuda. En caso de no presentación del paciente, no existirá devolución del dinero.

            El paciente deberá esperar un máximo de 10 minutos al profesional de la salud. Si en ese periodo el
            profesional de la salud no se conecta, la mesa de ayuda llamará al paciente para ofrecer alternativas para
            un reagendamiento o reembolso.
            Los reembolsos por citas canceladas se procesarán dentro de los 30 días hábiles posteriores a la
            cancelación, siempre que la cancelación se haya realizado dentro del plazo estipulado. Los reembolsos se
            realizarán al método de pago original utilizado para la cita u otro señalado por el paciente en un proceso
            manual de reembolso.
            <br>
            <br>
            <h4>PRECIOS</h4>
            <br>
            El precio de las consultas en la plataforma puede estar sujeto a cambios. Los usuarios podrán visualizar el
            precio actualizado del servicio al momento de realizar el agendamiento y el pago.
            <br>
            <br>
            <h4>PROPIEDAD INTELECTUAL E INDUSTRIAL – ENLACES</h4>
            <br>
            Todos los derechos de propiedad industrial e intelectual de este sitio, así como de los elementos contenidos
            en el mismo (incluyendo con carácter enunciativo pero no limitativo, marcas, signos distintivos, nombres
            comerciales, dominios, imágenes, fotografías, sonido, audio, video, diseño gráfico, código fuente, logos,
            contenidos, textos, gráficos, ilustraciones, bases de datos y demás elementos) son de la propiedad exclusiva
            de Almamedis, quien se reserva expresamente todos los derechos derivados del mismo.
            Los contenidos de las pantallas relativas a los servicios de Almamedis, así como también los programas,
            bases de datos, redes y/o archivos que permitan al usuario acceder y usar su cuenta, son propiedad de
            Almamedis y están protegidos por las leyes y los tratados internacionales de derecho de autor, marcas,
            patentes, modelos y diseños industriales.
            El Sitio puede contener enlaces a otros sitios web, lo cual no indica que sean propiedad u operados por
            Almamedis. En virtud de que Almamedis no tiene control sobre tales sitios, no será responsable por los
            contenidos, materiales, acciones y/o servicios prestados por los mismos, ni por eventuales daños o pérdidas
            ocasionadas por la utilización de éstos, sean causadas directa o indirectamente. La existencia de enlaces a
            otros sitios web no implica una sociedad, relación, aprobación, respaldo de Almamedis a dichos sitios y/o su
            contenido.
            Queda expresamente prohibida la reproducción, distribución o difusión de la totalidad o parte de los
            contenidos de este sitio con fines comerciales, sin la autorización expresa y escrita de Almamedis. El uso
            indebido y la reproducción total o parcial de dichos contenidos quedan prohibidos, salvo autorización
            expresa y por escrito de Almamedis.
            El Usuario se compromete a respetar los derechos de propiedad Intelectual e Industrial de Almamedis y deberá
            abstenerse de suprimir, alterar, eludir o manipular cualquier dispositivo de protección o sistema de
            seguridad que estuviera instalado en este sitio web.
            <br>
            <br>
            <h4>MODIFICACIONES</h4>
            <br>
            Almamedis se reserva el derecho de efectuar sin previo aviso las modificaciones y/o mejoras que considere
            oportunas en este sitio web, o en sus aplicaciones, pudiendo cambiar, suprimir o añadir enlaces, contenidos
            y servicios que se prestan a través del mismo y/o la forma en que aparezcan presentados.
            <br>
            <br>
            <h4>DERECHO DE EXCLUSIÓN</h4>
            <br>
            Almamedis se reserva el derecho de denegar o retirar el acceso a su sitio web y/o servicios ofrecidos a
            cualquier usuario que incumpla las condiciones estipuladas en estos Términos y Condiciones. El uso indebido
            o malicioso será notificado al Usuario.
            <br>
            <br>
            <h4>MODIFICACIONES DEL PRESENTE AVISO LEGAL</h4>
            <br>
            Almamedis se reserva el derecho a modificar, desarrollar o actualizar en cualquier momento, con previa
            notificación, los Términos y Condiciones de este sitio web. El Usuario deberá aceptar los Términos y
            Condiciones que se hallen vigentes en el momento en que acceda y haga uso de los servicios.
            <br>
            <br>
            <h4>DOMICILIO</h4>
            <br>
            Se fija como domicilio de Almamedis: Huérfanos #865, of. 1603, comuna y ciudad de Santiago, República de
            Chile.
            Si Usted tiene alguna duda sobre los Términos y Condiciones que rigen el Sitio o sobre los Servicios
            ofrecidos, deberá comunicarse con nuestro equipo de Atención al Cliente (contacto@almamedis.cl) para
            resolver dicha duda.
            <br>
            <br>
            <h4>NOTIFICACIONES</h4>
            <br>
            Almamedis utilizará diferentes medios de comunicación para notificar el resultado de ciertas acciones,
            procesos o procedimientos realizados por usted o de manera automática a nuestros sistemas. Dentro de estos
            canales de comunicación se encuentran los canales telefónicos, correo electrónico, mensajes de texto,
            mensajes instantáneos por la aplicación de mensajería WhatsApp, notificaciones de escritorio en los
            navegadores y notificaciones push provenientes de nuestra aplicación. Por la aceptación de los Términos y
            Condiciones, usted acepta recibir estas notificaciones en la línea telefónica, aplicaciones y cuentas que
            registre como propias en nuestra aplicación.
            <br>
            <br>
            <h4>ACEPTACIÓN Y AUTORIZACIÓN</h4>
            <br>
            Usted manifiesta que ha leído con detenimiento este documento, se obliga a cumplir con lo aquí estipulado,
            acepta expresamente todas las disposiciones en él contenidas y cumple con otorgar la autorización
            correspondiente en favor de Almamedis por el uso de esta plataforma y en beneficio de los Profesionales de
            la Salud, para los procedimientos y/o consultas que obtenga a través de la misma.
            El Usuario entiende que la aceptación de los Términos y Condiciones aquí contenidos, es equivalente a un
            contrato escrito y con este protocolo se da cumplimiento expreso a la legislación nacional vigente.
            <br>
            <br>
            <br>
            <br>
          </div>

        </div>
      </div>
    </div>
    <div class="footer">
      <button type="button" class="btn btn-aplicar" data-dismiss="modal" style="padding: 0 !important">Cerrar</button>
    </div>
  </div>
</div>

<ng-container>
  <app-payment-button [payment_button]='paymentInfo.transaction'></app-payment-button>
</ng-container>